import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgControlCharge = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M17 6.49994H3C1.89543 6.49994 1 7.39537 1 8.49994V16.4999C1 17.6045 1.89543 18.4999 3 18.4999H17C18.1046 18.4999 19 17.6045 19 16.4999V8.49994C19 7.39537 18.1046 6.49994 17 6.49994Z",
			fill: "#DBE4E8",
			stroke: "#293235",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 13.4999V11.4999",
			stroke: "#293235",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9801 10.8321C12.3716 11.2237 12.6381 11.7225 12.7461 12.2656C12.854 12.8087 12.7985 13.3716 12.5866 13.8831C12.3747 14.3947 12.0158 14.8319 11.5554 15.1395C11.095 15.4471 10.5537 15.6113 10 15.6113C9.44629 15.6113 8.90501 15.4471 8.44461 15.1395C7.9842 14.8319 7.62534 14.3947 7.41341 13.8831C7.20147 13.3716 7.14597 12.8087 7.25393 12.2656C7.36188 11.7225 7.62845 11.2237 8.01992 10.8321",
			stroke: "#293235",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0015 9.38858V12.4995",
			stroke: "#293235",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgControlCharge);
export { ForwardRef as ReactComponent };
